import { render, staticRenderFns } from "./ProductSectionPricing.vue?vue&type=template&id=7671f351"
import script from "./ProductSectionPricing.vue?vue&type=script&lang=js"
export * from "./ProductSectionPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports